import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { MULTIPLIERS_LIST_PATH } from 'components/Loyalty/Multipliers/config'

const STORAGE_KEY = 'multipliers-list'
const PARAM_VALUE = 'on'

const OLD_TAB_PATH = '/loyalty/bonuses'
const OVERVIEW_PATH = '/loyalty/overview'

const readStoredFlag = (): boolean => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === PARAM_VALUE
  } catch {
    return false
  }
}

const writeStoredFlag = () => {
  try {
    sessionStorage.setItem(STORAGE_KEY, PARAM_VALUE)
  } catch {
    // Blocked or full storage: the flag then lasts only while the query string does
  }
}

// Trailing slashes and case are ignored, as the router ignores them when matching routes
const redirectPath = (pathname: string, enabled: boolean): string | null => {
  const path = pathname.replace(/\/+$/, '').toLowerCase() || '/'

  if (enabled) {
    if (path === OLD_TAB_PATH) return MULTIPLIERS_LIST_PATH
    if (path === `${OLD_TAB_PATH}/new`) return `${MULTIPLIERS_LIST_PATH}/new`
    return null
  }

  if (path === MULTIPLIERS_LIST_PATH) return OLD_TAB_PATH
  if (path === `${MULTIPLIERS_LIST_PATH}/new`) return `${OLD_TAB_PATH}/new`
  if (path === '/loyalty/multipliers/create') return OVERVIEW_PATH
  if (/^\/loyalty\/multipliers\/[^/]+$/.test(path)) return OVERVIEW_PATH
  return null
}

/** Where a loyalty path should redirect for the given preview state, query string kept, or null to stay put. Exact paths only: the new tab's path contains the old one's. */
export const previewRedirect = (
  pathname: string,
  search: string,
  enabled: boolean
): string | null => {
  const target = redirectPath(pathname, enabled)
  return target ? `${target}${search}` : null
}

/** Dark-release flag for the multipliers list: on for the browser tab once `?multipliers-list=on` has been seen. Call it only from LoyaltyWrapper. */
export const useMultipliersPreview = (): boolean => {
  const { search } = useLocation()
  const inUrl = new URLSearchParams(search).get(STORAGE_KEY) === PARAM_VALUE

  useEffect(() => {
    if (inUrl) writeStoredFlag()
  }, [inUrl])

  return inUrl || readStoredFlag()
}
